import { getSmartFilterAxios } from '@/api/smartFilter.js';
import { sortByName } from '@/scripts/tools';

export default {
    state: {
        imageSmartFilters: [],

        isShowSmartFilterAdd: false,
        isSaveSmartFilterAdd: false,
        smartFilterDataAdd: {
            name: '',
            asset_type_id: null,
            is_hq: false,
            items: [],
            games: [],
            providers: [],
            tags: [],
            search_string: '',
        },

        isShowSmartFilterEdit: false,
        isSaveSmartFilterEdit: false,
        smartFilterDataEdit: null,
    },
    getters: {
        IMAGE_SMART_FILTERS: (state) => {
            return state.imageSmartFilters;
        },

        IS_SHOW_SMART_FILTER_ADD: (state) => {
            return state.isShowSmartFilterAdd;
        },
        IS_SAVE_SMART_FILTER_ADD: (state) => {
            return state.isSaveSmartFilterAdd;
        },
        SMART_FILTER_DATA_ADD: (state) => {
            return state.smartFilterDataAdd;
        },

        IS_SHOW_SMART_FILTER_EDIT: (state) => {
            return state.isShowSmartFilterEdit;
        },
        IS_SAVE_SMART_FILTER_EDIT: (state) => {
            return state.isSaveSmartFilterEdit;
        },
        SMART_FILTER_DATA_EDIT: (state) => {
            return state.smartFilterDataEdit;
        },
    },
    mutations: {
        IMAGE_SMART_FILTERS: (state, payload) => {
            if (payload.length === 0) return;

            payload.sort((a, b) => sortByName(a, b));
            state.imageSmartFilters = payload;
        },
        IMAGE_SMART_FILTERS_PUSH: (state, payload) => {
            state.imageSmartFilters.push(structuredClone(payload));
        },
        IMAGE_SMART_FILTER_UPDATE: (state, { id, payload }) => {
            const smartFilterIndex = state.imageSmartFilters
                .map((smart) => smart.id)
                .indexOf(id);
            state.imageSmartFilters[smartFilterIndex] =
                structuredClone(payload);
        },
        IMAGE_SMART_FILTER_SPLICE: (state, id) => {
            const smartFilterIndex = state.imageSmartFilters
                .map((smart) => smart.id)
                .indexOf(id);
            if (smartFilterIndex >= 0) {
                state.imageSmartFilters.splice(smartFilterIndex, 1);
            }
        },

        IS_SHOW_SMART_FILTER_ADD: (state, payload) => {
            state.isShowSmartFilterAdd = payload;
        },
        IS_SAVE_SMART_FILTER_ADD: (state, payload) => {
            state.isSaveSmartFilterAdd = payload;
        },
        SMART_FILTER_DATA_ADD_UPDATE: (state, { fieldName, fieldValue }) => {
            state.smartFilterDataAdd[fieldName] = fieldValue;
        },
        SMART_FILTER_DATA_ADD_PUSH: (state, { fieldName, fieldValue }) => {
            if (
                state.smartFilterDataAdd[fieldName].includes(fieldValue) ===
                true
            )
                return;
            state.smartFilterDataAdd[fieldName].push(fieldValue);
        },
        SMART_FILTER_DATA_ADD_SPLICE: (state, { fieldName, fieldValue }) => {
            const fieldIndex =
                state.smartFilterDataAdd[fieldName].indexOf(fieldValue);
            if (fieldIndex >= 0) {
                state.smartFilterDataAdd[fieldName].splice(fieldIndex, 1);
            }
        },

        IS_SHOW_SMART_FILTER_EDIT: (state, payload) => {
            state.isShowSmartFilterEdit = payload;
        },
        IS_SAVE_SMART_FILTER_EDIT: (state, payload) => {
            state.isSaveSmartFilterEdit = payload;
        },
        SMART_FILTER_DATA_EDIT_SET: (state, payload) => {
            state.smartFilterDataEdit = structuredClone(payload);
        },
        SMART_FILTER_DATA_EDIT_UPDATE: (state, { fieldName, fieldValue }) => {
            state.smartFilterDataEdit[fieldName] = fieldValue;
        },
        SMART_FILTER_DATA_EDIT_PUSH: (state, { fieldName, fieldValue }) => {
            if (
                state.smartFilterDataEdit[fieldName].includes(fieldValue) ===
                true
            )
                return;
            state.smartFilterDataEdit[fieldName].push(fieldValue);
        },
        SMART_FILTER_DATA_EDIT_SPLICE: (state, { fieldName, fieldValue }) => {
            const fieldIndex =
                state.smartFilterDataEdit[fieldName].indexOf(fieldValue);
            if (fieldIndex >= 0) {
                state.smartFilterDataEdit[fieldName].splice(fieldIndex, 1);
            }
        },
    },
    actions: {
        CHECK_SMART_FILTER_AXIOS: async function (context) {
            const smartFilter = context.getters.IMAGE_SMART_FILTERS;

            if (smartFilter.length === 0) {
                const axiosPromise = await getSmartFilterAxios().catch(
                    (error) => {
                        return [];
                    }
                );
                return axiosPromise;
            }
            return [];
        },
        CHECK_SMART_FILTER_ADD: async function (context) {
            const data = context.getters.SMART_FILTER_DATA_ADD;

            if (data.name === '') {
                context.commit('IS_SAVE_SMART_FILTER_ADD', false);
                return 'To create a smart filter, enter a name';
            }

            context.commit('IS_SAVE_SMART_FILTER_ADD', true);
            return '';
        },
        CHECK_SMART_FILTER_EDIT: async function (context) {
            const data = context.getters.SMART_FILTER_DATA_EDIT;

            if (data.name === '') {
                context.commit('IS_SAVE_SMART_FILTER_EDIT', false);
                return 'To create a smart filter, enter a name';
            }

            context.commit('IS_SAVE_SMART_FILTER_EDIT', true);
            return '';
        },
    },
};
